import { memo, Fragment } from 'react';
import PropTypes from 'prop-types';
import { filter } from 'ramda';
import OrderSegmentTicket from './OrderSegmentTicket';
import { isPassengerLuggageTicket } from '../../../../../helpers/passenger-helper';
import * as Styled from './Style';
const renderLuggageTickets = (passenger, tickets) => {
  const luggageTickets = filter(isPassengerLuggageTicket(passenger), tickets);
  return luggageTickets.map(({
    id,
    ...ticket
  }, index) => /*#__PURE__*/React.createElement(OrderSegmentTicket, {
    key: id,
    id: id,
    index: index,
    isMulti: luggageTickets.length > 1,
    ...ticket
  }));
};
const OrderSegment = ({
  segment: {
    segmentId,
    segmentCityFrom,
    segmentCityTo,
    carrierName,
    tickets,
    dateTimeFrom
  }
}) => {
  const passengerTickets = filter(ticket => !ticket.isLuggage, tickets);
  return /*#__PURE__*/React.createElement(Styled.Root, {
    ket: segmentId
  }, /*#__PURE__*/React.createElement(Styled.Description, null, /*#__PURE__*/React.createElement(Styled.DescriptionDirection, null, `${segmentCityFrom} — ${segmentCityTo}`), /*#__PURE__*/React.createElement("div", null, carrierName)), /*#__PURE__*/React.createElement(Styled.Time, null, I18n.t('components.Order.departure'), ' ', I18n.l('date.formats.datetime', dateTimeFrom)), /*#__PURE__*/React.createElement(Styled.LocalTimeInfo, null, I18n.t('components.Order.local_time')), /*#__PURE__*/React.createElement("div", null, passengerTickets.map(({
    id,
    passenger,
    ...ticket
  }) => /*#__PURE__*/React.createElement(Fragment, {
    key: id
  }, /*#__PURE__*/React.createElement(OrderSegmentTicket, {
    id: id,
    passenger: passenger,
    ...ticket
  }), renderLuggageTickets(passenger, tickets)))));
};
OrderSegment.propTypes = {
  segment: PropTypes.shape({
    segmentId: PropTypes.string.isRequired,
    segmentCityFrom: PropTypes.string.isRequired,
    segmentCityTo: PropTypes.string.isRequired,
    carrierName: PropTypes.string.isRequired,
    dateTimeFrom: PropTypes.instanceOf(Date),
    tickets: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      seatNumber: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      passenger: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        secondName: PropTypes.string
      }),
      isLuggage: PropTypes.bool
    }))
  })
};
export default /*#__PURE__*/memo(OrderSegment);